import { GQLVariable } from "../../lib/variables.js";
import { useSingleTenantMutation } from "../../lib/useSingleTenantMutation.js";
const UPDATE_MEMBERSHIP_QUERY = `
	updateProjectMember(
		projectSlug: $projectSlug,
		identityId: $identityId,
		memberships: $memberships
	) {
		ok
		errors {
			code
		}
	}
`;
const MembershipInput = { graphQlType: "MembershipInput", required: false };
const updateMembershipVariables = {
  projectSlug: GQLVariable.Required(GQLVariable.String),
  identityId: GQLVariable.Required(GQLVariable.String),
  memberships: GQLVariable.Required(GQLVariable.List(MembershipInput))
};
const useUpdateProjectMembership = () => useSingleTenantMutation(
  UPDATE_MEMBERSHIP_QUERY,
  updateMembershipVariables
);
export {
  MembershipInput,
  useUpdateProjectMembership
};
//# sourceMappingURL=updateMembership.js.map
